var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelectFloor1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "2500px",
    height: "1270px",
    viewBox: "0 0 2500 1270",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "B",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    id: 2,
    d: "M997.863489,320.53627 L997.863489,843.45998 L207.618703,841.533646 L207.618703,577.7348 L463.0235,577.7348 L462.684856,320.53627 L997.863489,320.53627 Z",
    stroke: "#FFD426",
    strokeWidth: 3.07254098,
    fillOpacity: 0.2,
    fill: "#FFD426"
  }), /*#__PURE__*/React.createElement("path", {
    id: 3,
    d: "M1246.96313,320.53627 L1246.96313,1125.18414 L1000.93665,1125.46199 L1001.26198,320.53627 L1246.96313,320.53627 Z",
    stroke: "#FFD426",
    strokeWidth: 3.07254098,
    fillOpacity: 0.2,
    fill: "#FFD426",
    transform: "translate(1123.949580, 723.000000) scale(-1, 1) translate(-1123.949580, -723.000000) "
  }), /*#__PURE__*/React.createElement("path", {
    id: 4,
    d: "M1513.06957,320.53627 L1513.06957,1125.46373 L1250.03567,1125.46373 L1250.03567,320.53627 L1513.06957,320.53627 Z",
    stroke: "#FFD426",
    strokeWidth: 3.07254098,
    fillOpacity: 0.2,
    fill: "#FFD426",
    transform: "translate(1381.552621, 723.000000) scale(-1, 1) translate(-1381.552621, -723.000000) "
  }), /*#__PURE__*/React.createElement("path", {
    id: 5,
    d: "M1762.16921,320.53627 L1762.16921,1125.18414 L1516.14273,1125.46199 L1516.46806,320.53627 L1762.16921,320.53627 Z",
    stroke: "#FFD426",
    strokeWidth: 3.07254098,
    fillOpacity: 0.2,
    fill: "#FFD426",
    transform: "translate(1639.155662, 723.000000) scale(-1, 1) translate(-1639.155662, -723.000000) "
  }), /*#__PURE__*/React.createElement("path", {
    id: 6,
    d: "M2028.27565,320.53627 L2028.27565,861.46373 L1764.24135,861.46373 L1764.24135,320.53627 L2028.27565,320.53627 Z",
    stroke: "#FFD426",
    strokeWidth: 3.07254098,
    fillOpacity: 0.2,
    fill: "#FFD426",
    transform: "translate(1896.258503, 591.000000) scale(-1, 1) translate(-1896.258503, -591.000000) "
  }), /*#__PURE__*/React.createElement("path", {
    id: 7,
    d: "M2295.3825,320.53627 L2295.3825,861.179299 L2031.34915,861.462082 L2031.68597,320.53627 L2295.3825,320.53627 Z",
    stroke: "#FFD426",
    strokeWidth: 3.07254098,
    fillOpacity: 0.2,
    fill: "#FFD426",
    transform: "translate(2163.365346, 591.000000) scale(-1, 1) translate(-2163.365346, -591.000000) "
  }), /*#__PURE__*/React.createElement("path", {
    id: 8,
    d: "M2295.3825,864.53627 L2295.3825,1125.19357 L2031.35017,1125.46216 L2031.68495,864.53627 L2295.3825,864.53627 Z",
    stroke: "#FFD426",
    strokeWidth: 3.07254098,
    fillOpacity: 0.2,
    fill: "#FFD426",
    transform: "translate(2163.365346, 995.000000) scale(-1, 1) translate(-2163.365346, -995.000000) "
  }), /*#__PURE__*/React.createElement("path", {
    id: 1,
    d: "M734.758247,844.53627 L734.758247,1126.17116 L151.600309,1126.46296 L152.335718,844.53627 L734.758247,844.53627 Z",
    stroke: "#FFD426",
    strokeWidth: 3.07254098,
    fillOpacity: 0.2,
    fill: "#FFD426",
    transform: "translate(443.177271, 985.500000) scale(-1, 1) translate(-443.177271, -985.500000) "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectFloor1);
export default __webpack_public_path__ + "static/media/select-floor-1.91b87c2f.svg";
export { ForwardRef as ReactComponent };